<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="物流单号">
              <a-input v-model.trim="queryParam.logisticsNo" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="卡号">
              <a-input v-model.trim="queryParam.cardNo" placeholder=""/>
            </a-form-item>
          </a-col>
         <!-- <a-col :md="8" :sm="24">
            <a-form-item label="车牌号">
              <a-input v-model="queryParam.carlicence" placeholder=""/>
            </a-form-item>
          </a-col>-->
          <a-col :md="!advanced && 8 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                  <a-button style="margin-left: 8px" @click="() => {queryParam = {}; this.statusSelect = null}">重置</a-button>
                  <!-- <a-button style="margin-left: 8px" @click="handleExport()">导出</a-button>-->
                 <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'"/>
                  </a>-->
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
   <!-- <div class="table-operator">
      <a-button style="margin-left: 0px" type="primary" @click="handleExport()">导出</a-button>
    </div>-->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1300 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
    <span slot="serial" slot-scope="text, record, index">
      {{ index + 1 }}
    </span>

     <!-- <span slot="materielAction" slot-scope="text, record">
          <a @click="handleProDetail(record.materielVo)" class="ant-dropdown-link">{{text}}</a>
        </span>-->

      <span slot="action" slot-scope="text, record,index">
        <a @click="handleDetail(record)">详情</a>
      </span>
    </s-table>

    <!--<a-modal
      title="审核设置"
      style="top: 100px;"
      :width="300"
      v-model="visible"
      @ok="handleOk"
    >
      <a-form :form="form">
        <a-radio-group v-model="value">
          <a-radio :value="1" >通过</a-radio>
          <a-radio :value="3">拒绝</a-radio>
        </a-radio-group>
      </a-form>
    </a-modal>-->
  </a-card>
</template>

<script>
  import Vue from 'vue'
  import {ACCESS_TOKEN} from '@/store/mutation-types'
  import { STable } from '@/components'
  import { assayPage} from '@/api/logistics'
  import { formatDate } from '@/utils/date.js'
  import moment from 'moment'
  import { ReservationStatus } from '@/utils/config.js'
  import { getLogStatusTextByValue } from '@/utils/util'
  import storage from "@/utils/storage"
  import queryMixin from '@/mixins/queryMixin'

  export default {
    name: 'assayList',
    mixins: [queryMixin],
    components: {
      STable
    },
    data () {
      return {
        pageSizeOptionsList:['10'],
        description: '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
        visible: false,

        // form: null,
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: null,
        // 表头
        columns: [
          {
            title: '物流单号',
            dataIndex: 'logisticsNo',
            width: '200px',
            fixed: 'left'
          },
          {
            title: '车号',
            dataIndex: 'carlicence',
            width: '150px',
          },
          {
            title: '卡号',
            dataIndex: 'cardNo',
            width: '200px',
          },
          {
            title: '是否合格',
            dataIndex: 'result',
            width :'100px',
            customRender: (text, record) => {
              if(text ==1){
                return '合格'
              }else{
                return '不合格'
              }
            }
          },
          {
            title: '货物名称',
            dataIndex: 'materielName',
            width: '200px',
          },
          /*{
            title: 'SiO2',
            dataIndex: 'siO2',
            width: '100px',
          },
          {
            title: 'Al2O3',
            dataIndex: 'al2o3',
            width: '150px',
          },
          {
            title: 'Fe2O3',
            dataIndex: 'fe2o3',
            width: '150px',
          },
          {
            title: 'CaO',
            dataIndex: 'cao',
            width: '150px',
          },
          {
            title: 'MgO',
            dataIndex: 'mgO',
            width: '150px',
          },*/
          {
            title: '化验时间',
            dataIndex: 'updateTime',
            width: '280px',
            customRender: (text) => {
              let date = new Date(text)
              return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '操作',
            width: '130px',
            fixed: 'right',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return assayPage(Object.assign(parameter, this.queryParam))
            .then(res => {
              console.log('assayPage', res)
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],

        value: 1,
        reservationId: null,
        supplierSelect:null
      }
    },

    created () {
      // 初始化查询条件
      this.queryParam =  this.queryParam || {}
    },

    methods: {
      moment,

      filterOption (input, option) { // 用于下拉列表可搜索
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },

      handleEdit (record) {
        // 弹出框显示
        this.visible = true
        this.reservationId = record.id
      },
     /* handleOk () {
        const _this = this
        console.log(this.auditStatus)
        _this.confirmLoading = true
        reservationAudit(Object.assign({}, { 'reservationId': this.reservationId, 'auditStatus': this.value }))
          .then(res => {
            let message = '审核成功'
            if (_this.value === _this.config.ReservationStatus.REFUSED){
              message = '拒绝成功'
            }
            _this.$message.success(message)
            _this.$emit('ok')
            this.$refs.table.refresh()
          }).catch(() => {
        }).finally(() => {
          _this.confirmLoading = false
          this.visible = false
        })
      },*/

      handleDetail (record) {
        storage.save("cache-AssayDetail", JSON.stringify(record));
        this.$router.push({name: "AssayDetail"})
      },

     /* handleProDetail (record) {
        this.$router.push({name: "MaterielDetail", query: {datas: JSON.stringify(record)}})
      },*/

      toggleAdvanced () {
        this.advanced = !this.advanced
      },
    },
    watch: {

    }

  }
</script>
